<template>
  <div class="card">
    <div class="card-header py-2 px-2 d-flex justify-content-between align-items-center font-weight-bold">
      Rule Search
    </div>
    <div class="card-body py-2 px-2">
      <form @submit.prevent="handleSearch">
        <div class="form-row">
          <div class="form-group m-0 col">
            <label class="text-truncate d-block small mb-0">Created Between</label>
            <input
              type="date"
              required
              class="form-control d-inline-flex"
              :disabled="loading"
              v-model="search.dateFrom"
            >
          </div>
          <div class="form-group m-0 col">
            <label class="text-truncate d-block small mb-0">&nbsp;</label>
            <input
              type="date"
              required
              class="form-control d-inline-flex"
              :disabled="loading"
              v-model="search.dateTo"
            >
          </div>
          <div class="form-group m-0 col">
            <label class="text-truncate d-block small mb-0">Created By</label>
            <select
              class="form-control"
              :disabled="loading"
              v-model="search.user"
            >
              <option
                :value="option.value"
                v-for="option in userOptions"
                :key="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div class="form-group m-0 col">
            <label class="text-truncate d-block small mb-0">Login</label>
            <input
              class="form-control"
              type="text"
              placeholder="TSW37781"
              v-model.trim="search.login"
            >
          </div>
          <div class="form-group m-0 col">
            <label class="text-truncate d-block small mb-0">&nbsp;</label>
            <button
              type="submit"
              class="btn btn-info w-100 font-weight-bold"
              :disabled="loading"
            >
              Search Rules<i class="jam jam-search ml-1" />
            </button>
          </div>
        </div>
        <div class="form-row mt-1">
          <div class="col">
            <label class="text-truncate d-inline-block small mb-0 mr-2">Rule Types:</label>
            <div
              class="form-check-inline"
              v-for="type in ruleTypes"
              :key="type"
            >
              <input
                type="checkbox"
                class="form-check-input"
                :value="type"
                disabled
                :checked="type in search.types && search.types[type] === true"
                v-model="search.types[type]"
              >
              <label class="form-check-label small text-capitalize">{{ type }}</label>
            </div>
          </div>
        </div>
      </form>

      <template v-if="search.results.length > 0">
        <hr>
        <template v-if="loginResults.length > 0">
          <p class="font-weight-bold">
            {{ loginResults.length }} Login Rule(s) Found
          </p>
          <div class="form-row">
            <template v-for="result in loginResults">
              <rule-search-item
                :key="result.id"
                :item="result"
                class="mb-2"
              />
            </template>
          </div>
          <hr v-if="propertyResults.length > 0">
        </template>
        <template v-if="propertyResults.length > 0">
          <p class="font-weight-bold">
            {{ propertyResults.length }} Property Rule(s) Found
          </p>
          <div class="form-row">
            <template v-for="result in propertyResults">
              <rule-search-item
                :key="result.id"
                :item="result"
                class="mb-2"
              />
            </template>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import http from '../../http';

import { ruleTypes } from './consts';
import RuleSearchItem from './RuleSearchItem.vue';

const types = {};
ruleTypes.forEach( type => {
    types[ type ] = true;
} );

export default {
    data: () => ( {
        loading: false,
        search: {
            dateFrom: moment().subtract( 1, 'week' ).format( 'YYYY-MM-DD' ),
            dateTo: moment().format( 'YYYY-MM-DD' ),
            scope: 'all',
            types: types,
            user: 'any',
            login: '',
            results: []
        },
        userOptions: [
            {
                value: 'any',
                label: 'Anyone'
            }
        ]
    } ),
    computed: {
        ruleTypes() {
            return ruleTypes;
        },
        searchParams() {
            const params = new URLSearchParams();

            params.set( 'dateFrom', this.search.dateFrom );
            params.set( 'dateTo', this.search.dateTo );
            params.set( 'scope', this.search.scope );

            if ( this.search.user !== 'any' ) {
                params.set( 'user', this.search.user );
            }

            if ( this.search.login.length > 0 ) {
                params.set( 'login', this.search.login );
            }

            Object.keys( this.search.types ).forEach( type => params.set( type, true ) );

            return params.toString();
        },
        results() {
            return this.search.results.map( r => {
                let newR = r;
                newR.rules = JSON.parse( r.rules );
                return newR;
            } ).filter( r => r.rules.length > 0 );
        },
        loginResults() {
            return this.results.filter( r => r.login.length > 0 && r.propertyID === 0 );
        },
        propertyResults() {
            return this.results.filter( r => r.login.length === 0 && r.propertyID !== 0 );
        }
    },
    methods: {
        async handleSearch() {
            this.$store.dispatch( 'appLoading', true );

            const searchResponse = await http.get( `property-qc/search-rules?${this.searchParams}` );

            if ( searchResponse.status !== 200 && searchResponse.status !== 204 ) {
                return;
            }

            this.search.results = await searchResponse.json();

            this.$store.dispatch( 'appLoading', false );
        }
    },
    async created() {
        this.loading = true;

        const userResponse = await http.get( '/property-qc/rule-users' );

        if ( userResponse.status !== 200 ) {
            return;
        }

        const data = await userResponse.json();

        this.userOptions = [].concat( this.userOptions, data.map( email => {
            return {
                value: email,
                label: email
            };
        } ) );

        this.loading = false;
    },
    components: {
        RuleSearchItem
    }
};
</script>



// WEBPACK FOOTER //
// src/components/property-qc/RuleSearch.vue